import { render, staticRenderFns } from "./PositionSoftwareRelate.vue?vue&type=template&id=5c3b4c87"
import script from "./PositionSoftwareRelate.vue?vue&type=script&lang=js"
export * from "./PositionSoftwareRelate.vue?vue&type=script&lang=js"
import style0 from "./PositionSoftwareRelate.vue?vue&type=style&index=0&id=5c3b4c87&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports